"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("../Observable/Observable");
var ConfigState = /** @class */ (function () {
    function ConfigState() {
        this.log = null;
        this.maxHistoryLength = 10;
        this.observable = Observable_1.default;
        Object.seal(this);
    }
    return ConfigState;
}());
exports.default = ConfigState;
//# sourceMappingURL=ConfigState.js.map